"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _AdresseBase = _interopRequireDefault(require("./AdresseBase"));
var _DateiBase = _interopRequireDefault(require("./DateiBase"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * KFV LDS API
 * Die KFV LDS API bietet eine Schnittstelle zum Backend der PWA.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The FortbildungCreate model module.
 * @module model/FortbildungCreate
 * @version 0.0.1
 */
class FortbildungCreate {
  /**
   * Constructs a new <code>FortbildungCreate</code>.
   * @alias module:model/FortbildungCreate
   * @param typ {String} 
   * @param titel {String} 
   * @param beschreibung {String} 
   * @param kapazitaet {Number} 
   * @param datum {Date} 
   * @param ende {Date} 
   */
  constructor(typ, titel, beschreibung, kapazitaet, datum, ende) {
    FortbildungCreate.initialize(this, typ, titel, beschreibung, kapazitaet, datum, ende);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj, typ, titel, beschreibung, kapazitaet, datum, ende) {
    obj['typ'] = typ;
    obj['titel'] = titel;
    obj['beschreibung'] = beschreibung;
    obj['kapazitaet'] = kapazitaet;
    obj['datum'] = datum;
    obj['ende'] = ende;
  }

  /**
   * Constructs a <code>FortbildungCreate</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/FortbildungCreate} obj Optional instance to populate.
   * @return {module:model/FortbildungCreate} The populated <code>FortbildungCreate</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new FortbildungCreate();
      if (data.hasOwnProperty('typ')) {
        obj['typ'] = _ApiClient.default.convertToType(data['typ'], 'String');
      }
      if (data.hasOwnProperty('titel')) {
        obj['titel'] = _ApiClient.default.convertToType(data['titel'], 'String');
      }
      if (data.hasOwnProperty('beschreibung')) {
        obj['beschreibung'] = _ApiClient.default.convertToType(data['beschreibung'], 'String');
      }
      if (data.hasOwnProperty('kapazitaet')) {
        obj['kapazitaet'] = _ApiClient.default.convertToType(data['kapazitaet'], 'Number');
      }
      if (data.hasOwnProperty('notify_leiter')) {
        obj['notify_leiter'] = _ApiClient.default.convertToType(data['notify_leiter'], 'Boolean');
      }
      if (data.hasOwnProperty('notify_ortswehrfuehrer')) {
        obj['notify_ortswehrfuehrer'] = _ApiClient.default.convertToType(data['notify_ortswehrfuehrer'], 'Boolean');
      }
      if (data.hasOwnProperty('datum')) {
        obj['datum'] = _ApiClient.default.convertToType(data['datum'], 'Date');
      }
      if (data.hasOwnProperty('ende')) {
        obj['ende'] = _ApiClient.default.convertToType(data['ende'], 'Date');
      }
      if (data.hasOwnProperty('adresse')) {
        obj['adresse'] = _AdresseBase.default.constructFromObject(data['adresse']);
      }
      if (data.hasOwnProperty('bild')) {
        obj['bild'] = _DateiBase.default.constructFromObject(data['bild']);
      }
      if (data.hasOwnProperty('datei')) {
        obj['datei'] = _DateiBase.default.constructFromObject(data['datei']);
      }
      if (data.hasOwnProperty('meetingLink')) {
        obj['meetingLink'] = _ApiClient.default.convertToType(data['meetingLink'], 'String');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>FortbildungCreate</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>FortbildungCreate</code>.
   */
  static validateJSON(data) {
    // check to make sure all required properties are present in the JSON string
    for (const property of FortbildungCreate.RequiredProperties) {
      if (!data[property]) {
        throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
      }
    }
    // ensure the json data is a string
    if (data['typ'] && !(typeof data['typ'] === 'string' || data['typ'] instanceof String)) {
      throw new Error("Expected the field `typ` to be a primitive type in the JSON string but got " + data['typ']);
    }
    // ensure the json data is a string
    if (data['titel'] && !(typeof data['titel'] === 'string' || data['titel'] instanceof String)) {
      throw new Error("Expected the field `titel` to be a primitive type in the JSON string but got " + data['titel']);
    }
    // ensure the json data is a string
    if (data['beschreibung'] && !(typeof data['beschreibung'] === 'string' || data['beschreibung'] instanceof String)) {
      throw new Error("Expected the field `beschreibung` to be a primitive type in the JSON string but got " + data['beschreibung']);
    }
    // validate the optional field `adresse`
    if (data['adresse']) {
      // data not null
      _AdresseBase.default.validateJSON(data['adresse']);
    }
    // validate the optional field `bild`
    if (data['bild']) {
      // data not null
      _DateiBase.default.validateJSON(data['bild']);
    }
    // validate the optional field `datei`
    if (data['datei']) {
      // data not null
      _DateiBase.default.validateJSON(data['datei']);
    }
    // ensure the json data is a string
    if (data['meetingLink'] && !(typeof data['meetingLink'] === 'string' || data['meetingLink'] instanceof String)) {
      throw new Error("Expected the field `meetingLink` to be a primitive type in the JSON string but got " + data['meetingLink']);
    }
    return true;
  }
}
FortbildungCreate.RequiredProperties = ["typ", "titel", "beschreibung", "kapazitaet", "datum", "ende"];

/**
 * @member {String} typ
 */
FortbildungCreate.prototype['typ'] = undefined;

/**
 * @member {String} titel
 */
FortbildungCreate.prototype['titel'] = undefined;

/**
 * @member {String} beschreibung
 */
FortbildungCreate.prototype['beschreibung'] = undefined;

/**
 * @member {Number} kapazitaet
 */
FortbildungCreate.prototype['kapazitaet'] = undefined;

/**
 * @member {Boolean} notify_leiter
 * @default false
 */
FortbildungCreate.prototype['notify_leiter'] = false;

/**
 * @member {Boolean} notify_ortswehrfuehrer
 * @default false
 */
FortbildungCreate.prototype['notify_ortswehrfuehrer'] = false;

/**
 * @member {Date} datum
 */
FortbildungCreate.prototype['datum'] = undefined;

/**
 * @member {Date} ende
 */
FortbildungCreate.prototype['ende'] = undefined;

/**
 * @member {module:model/AdresseBase} adresse
 */
FortbildungCreate.prototype['adresse'] = undefined;

/**
 * @member {module:model/DateiBase} bild
 */
FortbildungCreate.prototype['bild'] = undefined;

/**
 * @member {module:model/DateiBase} datei
 */
FortbildungCreate.prototype['datei'] = undefined;

/**
 * @member {String} meetingLink
 */
FortbildungCreate.prototype['meetingLink'] = undefined;
var _default = exports.default = FortbildungCreate;